import apiService from './api-service';

export const companyService = {
	getCompanies
};

async function getCompanies() {
	const companies = await apiService.get('company/getCompanies');
	return companies;
}